import { useContext } from "react";
import { StickyBottomBarContext } from "./StickyBottomBarContext";

export const useStickyBottomBarContext = () => {
  const context = useContext(StickyBottomBarContext);
  if (context === undefined) {
    throw new Error("useStickyBottomBarContext must be used within a StickyBottomBarContextProvider");
  }

  return context;
};
